import React from 'react';
import { CommonIconProps } from './Icon';

const XIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.7855 4.63888C22.4549 3.9694 22.4549 2.88398 21.7855 2.2145C21.1161 1.54504 20.0306 1.54504 19.3611 2.2145L12 9.57564L4.63888 2.2145C3.9694 1.54504 2.88398 1.54504 2.2145 2.2145C1.54504 2.88398 1.54504 3.9694 2.2145 4.63888L9.57564 12L2.2145 19.3611C1.54504 20.0306 1.54504 21.1161 2.2145 21.7855C2.88398 22.4549 3.9694 22.4549 4.63888 21.7855L12 14.4244L19.3611 21.7855C20.0306 22.4549 21.1161 22.4549 21.7855 21.7855C22.4549 21.1161 22.4549 20.0306 21.7855 19.3611L14.4244 12L21.7855 4.63888Z"
      fill={color}
    />
  </>
);

export default XIcon;
